import React from 'react'

const Button = ({text}) => {
  return (
   <>
   <button type="submit" className="contact-btn">
              {text}
            </button>
   </>
  )
}

export default Button
